import React from 'react';
import PropTypes from 'prop-types';
import { useIsNodeActive } from './MenuNodeActive';
import { MenuContext } from '../../MenuContext';

export const MenuParentNode = (
    {
        icon,
        label,
        children,
        activeRoutes,
    },
) => {
    const { currentPathName } = React.useContext(MenuContext);
    const activeClass = useIsNodeActive(activeRoutes, currentPathName);

    return (
        <li className={activeClass}>
            <a className="menu-toggle">
                <i className="material-icons">{icon}</i>
                <span>{label}</span>
            </a>
            <ul className="ml-menu">
                {children}
            </ul>
        </li>
    );
};

MenuParentNode.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    activeRoutes: PropTypes.array.isRequired,
};

MenuParentNode.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/menu-nodes/MenuParentNode.jsx